import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const taskVuex = createNamespacedHelpers("task");
import formatter from "@utils/formatter";
import vailcode from "@utils/errcode";
import { address, toNano } from "@ton/core";
export default {
  name: "popNftShards",
  props: {
    list: null
  },
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "tonConnect"]),
    ...taskVuex.mapState(["timerObjs"]),
    fmt_pre() {
      return formatter.fmt_pre;
    }
  },
  data() {
    return {
      pricesList: null,
      rowPrice: null,
      selectPayMethodShow: false,
      selectPay: "Stars",
      isCheckBtn: false
    };
  },
  watch: {
    list: {
      handler(newVal) {
        this.pricesList = newVal;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    clearPop() {
      this.pricesList[this.rowPrice.index].isLoading = false;
      this.selectPayMethodShow = false;
      this.isCheckBtn = false;
      this.$nextTick(() => {
        this.$parent.popNFTShardsShow = false;
      });
    },
    showReward(data) {
      this.$parent.rewardData = {
        count: this.rowPrice.count,
        balance: this.$parent.NFTBalance,
        newBalance: data.newBalance
      };
      console.log("this.$parent.rewardData", this.$parent.rewardData);
      this.$nextTick(() => {
        this.$parent.popRewardShow = true;
      });
    },
    onSelectPay(type) {
      this.selectPay = type;
    },
    async onNFTBuy(item, index) {
      this.rowPrice = {
        ...item,
        index
      };
      this.selectPayMethodShow = true;
    },
    NFTBuy(params) {
      return new Promise(async resolve => {
        const res = await this.$http.post("/nft/fragment/buy", params);
        // const res = {
        //   code: 0,
        //   message: "",
        //   data: {
        //     balance: 10015,
        //   },
        // };
        // const res = {
        //   code: 0,
        //   message: "",
        //   data: {
        //     chainInfo: {
        //       order_id: 253,
        //       payment_url: "https://t.me/$P63qiw1GKFO2AwAAlyHe2bhil3U",
        //       deposit_id: 555,
        //     },
        //     paymentId: 5,
        //   },
        // };
        if (res.code > 0) {
          resolve(res);
          return;
        }
        resolve(res);
      });
    },
    async poolCheckPay(resp, timer) {
      return new Promise(async resolve => {
        const fnc = async resp => {
          const rowPrice = this.rowPrice;
          this.timerObjs.NFTPage.NFTPayTimer = setTimeout(async () => {
            let params = {
              index: rowPrice.index,
              currency: this.selectPay,
              address: this.tonWallet.uiAddress,
              paymentId: this.pricesList[rowPrice.index].paymentId
            };
            console.log("paramsparams555", params);
            const res = await this.NFTBuy(params);
            console.log("resresresres23333", res);
            if (!res) {
              this.$toasted.error("Buy failed, please try again");
              this.pricesList[rowPrice.index].isLoading = false;
              resolve();
            } else if (res.code == 302) {
              clearTimeout(this.timerObjs.NFTPage.NFTPayTimer);
              await fnc(resp);
            } else if (res.code > 0) {
              this.pricesList[this.rowPrice.index].isLoading = false;
              clearTimeout(this.timerObjs.NFTPage.NFTPayTimer);
              this.$toasted.error(res.message);
              resolve();
            } else {
              clearTimeout(this.timerObjs.NFTPage.NFTPayTimer);
              this.pricesList[rowPrice.index].isLoading = false;
              resolve(res);
            }
          }, timer * 1000);
        };
        await fnc(resp);
      });
    },
    async onPayCheckBtn() {
      const rowPrice = this.rowPrice;
      if (this.pricesList[rowPrice.index].isCheckLoading) return;
      this.pricesList[rowPrice.index].isCheckLoading = true;
      console.log("rowPricerowPricerowPrice", rowPrice);
      let params = {
        index: rowPrice.index,
        currency: this.selectPay,
        paymentId: this.pricesList[rowPrice.index].paymentId
      };
      if (this.selectPay === "TON") {
        params["address"] = this.tonWallet.uiAddress;
      }
      const res = await this.NFTBuy(params);
      console.log("resresresres23333", res);
      if (!res) {
        this.$toasted.error("Buy failed, please try again");
        this.pricesList[rowPrice.index].isCheckLoading = false;
        return;
      } else if (res.code == 302) {
        this.$toasted.info(res.message);
        this.pricesList[rowPrice.index].isCheckLoading = false;
        return;
      } else if (res.code > 0) {
        this.pricesList[rowPrice.index].isCheckLoading = false;
        this.$toasted.error(res.message);
        return;
      }
      clearTimeout(this.timerObjs.NFTPage.NFTPayTimer);
      this.pricesList[rowPrice.index].isCheckLoading = false;
      this.pricesList[rowPrice.index].isLoading = true;
      this.pricesList[rowPrice.index].paymentId = null;
      this.clearPop();
      this.showReward({
        ...res.data,
        newBalance: res.data.balance
      });
    },
    async onPayment() {
      console.log("this.selectPay", this.selectPay, this.tonConnect, this.tonWallet);
      const fnc = async () => {
        const params = {
          index: this.rowPrice.index,
          currency: this.selectPay
        };
        if (this.selectPay === "TON") {
          params["address"] = this.tonWallet.uiAddress;
        }
        if (this.pricesList[this.rowPrice.index].isLoading) return;
        this.pricesList[this.rowPrice.index].isLoading = true;
        const res = await this.NFTBuy(params);
        if (!res) {
          this.pricesList[this.rowPrice.index].isLoading = false;
          return;
        }
        let data = res.data;
        console.log("data123", data);
        if (this.selectPay === "TON" && data?.chainInfo) {
          let msg = [{
            address: data.chainInfo.contract,
            amount: toNano(data.chainInfo.amount).toString(),
            payload: data.chainInfo.raw
          }];
          const payRef = await _v.tonWallet.sendTransaction(msg);
          console.log("payRefpayRef123", payRef);
          if (!payRef) {
            this.pricesList[this.rowPrice.index].isLoading = false;
            return;
          }
          this.pricesList[this.rowPrice.index].paymentId = data.paymentId;
          console.log("this.rowPricethis.rowPrice", this.rowPrice);
          this.isCheckBtn = true;
          const upRes = await this.poolCheckPay(data, 9);
          console.log("upRes123", upRes);
          this.isCheckBtn = false;
          if (!upRes) return;
          this.clearPop();
          this.pricesList[this.rowPrice.index].paymentId = null;
          this.showReward({
            ...upRes.data,
            newBalance: upRes.data.balance
          });
        } else if (this.selectPay === "Stars" && data?.chainInfo) {
          const payRef = await this.openInvoiceStarPay({
            url: data.chainInfo.payment_url
          });
          if (!payRef) {
            this.pricesList[this.rowPrice.index].isLoading = false;
            return;
          }
          this.isCheckBtn = true;
          this.pricesList[this.rowPrice.index].paymentId = data.paymentId;
          console.log("32321313123", data, this.pricesList[this.rowPrice.index].paymentId);
          console.log("this.rowPricethis.rowPrice123", this.rowPrice);
          const upRes = await this.poolCheckPay(data, 3);
          this.isCheckBtn = false;
          if (!upRes) return;
          this.clearPop();
          this.pricesList[this.rowPrice.index].paymentId = null;
          this.showReward({
            ...upRes.data,
            newBalance: upRes.data.balance
          });
        } else {
          this.clearPop();
          this.showReward({
            ...data,
            newBalance: res.data.balance
          });
        }
      };
      if (this.selectPay === "TON" && !this.tonConnect) {
        this.$nextTick(() => {
          this.tonWallet.openOrCloseTonModal(true);
          this.tonWallet.ton.onStatusChange(async walletAndwalletInfo => {
            if (walletAndwalletInfo) {
              fnc();
            }
          });
        });
      } else {
        fnc();
      }
    },
    //星星支付
    openInvoiceStarPay(params) {
      return new Promise(async resolve => {
        const res = await _v.WebApp.openInvoice(params.url);
        async function invoiceClosedFnc(e) {
          console.log("ressssssss", res, e?.status);
          if (e?.status && e.status == "paid") {
            resolve(1);
          } else if (e?.status && e.status === "cancelled") {
            resolve();
          }
        }
        _v.WebApp.onEvent("invoiceClosed", invoiceClosedFnc);
      });
    }
  }
};